import { Link } from '@tanstack/react-router'
import { X } from 'lucide-react'
import type { MouseEvent } from 'react'

import { Button } from '@/ui/button'

export type SubjectKind = 'user' | 'machine' | 'group'

type SubjectProps = {
  kind: SubjectKind
  name: string
  href?: string
  label?: never
  onRemove?: never
  removeLabel?: never
}

type StaticLabelProps = {
  label: string
  kind?: never
  name?: never
  href?: never
  onRemove?: never
  removeLabel?: never
}

type RemovableRoleProps = {
  label: string
  onRemove: (event: MouseEvent<HTMLButtonElement>) => void
  removeLabel: string
  kind?: never
  name?: never
  href?: never
}

type SubjectChipProps = SubjectProps | StaticLabelProps | RemovableRoleProps

const chipClassName =
  'text-foreground inline-flex items-center rounded-full bg-foreground/[0.06] px-2 py-0.5 text-[10px] font-medium'

function SubjectChip(props: SubjectChipProps) {
  if ('label' in props) {
    return (
      <span data-slot="subject-chip" className={chipClassName}>
        {props.label}
        {props.onRemove ? (
          <Button
            type="button"
            variant="ghost"
            size="icon-sm"
            aria-label={props.removeLabel}
            onClick={props.onRemove}
            className="-mr-1 rounded-full"
          >
            <X className="size-2.5" aria-hidden="true" />
          </Button>
        ) : null}
      </span>
    )
  }

  const { kind, name, href } = props

  return (
    <span data-slot="subject-chip" className="inline-flex items-center gap-2">
      <span className={chipClassName}>
        {kind === 'group' ? 'Group' : kind === 'machine' ? 'Service account' : 'User'}
      </span>
      {href ? (
        <Link to={href} className="text-foreground hover:underline">
          {name}
        </Link>
      ) : (
        <span className="text-foreground">{name}</span>
      )}
    </span>
  )
}

export { SubjectChip }
